import React, { Fragment } from 'react';
import { CardBody, Card, CardTitle } from 'reactstrap';
import ReactEcharts from 'echarts-for-react';

const Pie = ({
  options = [
    { value: 335, name: 'Laptop' },
    { value: 310, name: 'Tablet' },
    { value: 234, name: 'Mobile' },
    { value: 135, name: 'Others' },
    { value: 1548, name: 'Desktop' },
  ],
  colors = ['#02a499', '#f8b425', '#ec4561', '#38a4f8', '#3c4ccf'],
  margin = ['50%', '60%'],
  height = 250,
  title = '',
  name = 'Total Pegawai',
}) => {
  const getOption = () => {
    let legend = [];
    options.forEach((element) => {
      legend.push(element.name);
    });
    return {
      toolbox: {
        show: false,
        feature: {
          saveAsImage: {},
        },
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        data: legend,
        textStyle: {
          color: ['#74788d'],
        },
      },
      color: colors,
      series: [
        {
          name: name,
          type: 'pie',
          radius: '55%',
          center: margin,
          data: options,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
  };

  return (
    <Fragment>
      <ReactEcharts option={getOption()} />
    </Fragment>
  );
};

export default Pie;
